import { createSlice } from "@reduxjs/toolkit";
import { getMonthsInRange } from "../common/utils/helperFunctions";

// Shape mirrors GET /index/stats/search response - months is always an array
// per the API contract, so consumers can rely on it without `?.` fallbacks.
const COLLECTION_STATS = {
  firstItemDatetime: null,
  lastItemDatetime: null,
  months: [],
};

const initialState = {
  startDate: null,
  endDate: null,
  defaultExplorerLimit: 100,
  defaultSearchLimit: 20,
  monthRange: [],
  filteredCollection: {},
  filteredCollections: [],
  filterDataType: 'Collection',
  collectionStats: COLLECTION_STATS,
  loadingCollectionStats: false,
};

const filtersSlice = createSlice({
  name: "filtersSlice",
  initialState,
  reducers: {
    updateDateRange: (state, action) => {
      state.startDate = action.payload.startDate;
      state.endDate = action.payload.endDate;
      state.monthRange = getMonthsInRange(
        new Date(action.payload.startDate),
        new Date(action.payload.endDate)
      );
    },
    updateFilteredCollection: (state, action) => {
      state.filteredCollection = action.payload;
    },
    updateFilteredCollections: (state, action) => {
      state.filteredCollections = action.payload;
    },
    updateFilterDataType: (state, action) => {
      state.filterDataType = action.payload;
    },
    updateDate: (state, action) => {
      state.startDate = action.payload.startDate;
      state.endDate = action.payload.endDate;
    },
    getCollectionStatsRequest: (state) => {
      state.loadingCollectionStats = true;
    },
    getCollectionStatsSuccess: (state, action) => {
      state.loadingCollectionStats = false;
      state.collectionStats = action.payload;
    },
    getCollectionStatsFailure: (state) => {
      state.loadingCollectionStats = false;
      state.collectionStats = COLLECTION_STATS;
    },
  },
});

export default filtersSlice.reducer;

export const {
  updateDateRange,
  updateFilteredCollection,
  updateFilteredCollections,
  updateFilterDataType,
  updateDate,
  getCollectionStatsRequest,
  getCollectionStatsSuccess,
  getCollectionStatsFailure,
} = filtersSlice.actions;
